import React from 'react';
import { NavLink, useLocation } from 'react-router-dom';
interface TabItem {
  label: string;
  path: string;
}
interface TabNavigationProps {
  tabs: TabItem[];
  basePath: string;
}
export function TabNavigation({
  tabs,
  basePath
}: TabNavigationProps) {
  return <div className="flex border-b border-white/10 mb-6 overflow-x-auto" data-id="element-170">
      {tabs.map(tab => <NavLink key={tab.path} to={`${basePath}/${tab.path}`} end={tab.path === ''} className={({
      isActive
    }) => `
            px-4 py-3 text-sm font-medium transition-colors relative whitespace-nowrap
            ${isActive ? 'text-accent-primary' : 'text-text-secondary hover:text-text-primary hover:bg-white/5'}
          `} data-id="element-171">
          {({
        isActive
      }) => <>
              {tab.label}
              {isActive && <div className="absolute bottom-0 left-0 w-full h-0.5 bg-accent-primary rounded-t-full" data-id="element-172" />}
            </>}
        </NavLink>)}
    </div>;
}